module.exports = __webpack_public_path__ + "static/img/bg-slight-production-video.567c85f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/video/bg-slight-production-video.jpg
// module id = Xb30
// module chunks = 1